import { render, staticRenderFns } from "./ProductPhoto.vue?vue&type=template&id=5d6edf1c&scoped=true&"
import script from "./ProductPhoto.vue?vue&type=script&lang=js&"
export * from "./ProductPhoto.vue?vue&type=script&lang=js&"
import style0 from "./ProductPhoto.vue?vue&type=style&index=0&id=5d6edf1c&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6edf1c",
  null
  
)

export default component.exports